"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Contact_1 = require("../Contact");
const UserUtils_1 = require("./UserUtils");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
class UserDto {
    constructor(u) {
        this.id = "";
        this.username = "";
        this.displayname = "";
        this.isOnline = false;
        this.avatar = "";
        this.contacts = [];
        if (u) {
            this.id = u.id || this.id;
            this.username = u.username || this.username;
            this.displayname = u.displayname || this.displayname;
            this.isOnline = u.isOnline || this.isOnline;
            this.avatar = u.avatar || this.avatar;
            this.contacts = u.contacts ? TypeScriptUtils_1.iterableObjToTypedArray(u.contacts, Contact_1.Contact) : this.contacts;
            this.contacts = u.contacts ? u.contacts.slice() : this.contacts;
        }
    }
    toString() {
        return JSON.stringify(this);
    }
    hasContact(userId) { return UserUtils_1.UserUtils.HasContact(this.contacts, userId); }
    hasAddedContact(userId) { return UserUtils_1.UserUtils.HasAddedContact(this.contacts, userId); }
    isFavoriteContact(userId) { return UserUtils_1.UserUtils.IsFavoriteContact(this.contacts, userId); }
    favoriteContactOfId(aUserId) { return UserUtils_1.UserUtils.FavoriteContactOfId(this.contacts, aUserId); }
    isValid() {
        return UserUtils_1.UserUtils.IsValid(this.id, this.username);
    }
}
UserDto.INVALID_USER = new UserDto();
exports.UserDto = UserDto;
function newUserDto(u) {
    if (!u || u === UserDto.INVALID_USER)
        return UserDto.INVALID_USER;
    else if (!UserUtils_1.UserUtils.IsValid(u.id, u.username))
        return UserDto.INVALID_USER;
    else
        return new UserDto(u);
}
exports.newUserDto = newUserDto;
//# sourceMappingURL=UserDto.js.map